export const slogan = '2048.ink is now live!';
export const link2048evm = 'https://2048.evm.ink/mint';
